import { render, staticRenderFns } from "./DocCard.vue?vue&type=template&id=d9080588&scoped=true&"
import script from "./DocCard.vue?vue&type=script&lang=js&"
export * from "./DocCard.vue?vue&type=script&lang=js&"
import style0 from "./DocCard.vue?vue&type=style&index=0&id=d9080588&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9080588",
  null
  
)

export default component.exports